<template>
  <div class="mt-4 mb-4">
    <div v-if="currentCandidature && currentActivite">
      <div class="row">
        <div class="col-md-12 col-lg-6 offset-lg-6">
          <table
            class="card table table-sm table-custom-primary table-bordered mb-0"
          >
            <tbody>
              <tr class="d-flex font-size-17 font-weight-bold">
                <td class="col-12">
                  <span class="text-custom-primary">
                    Appréciation de l'activité :</span
                  >

                  {{
                    currentActivite.appreciation
                      ? currentActivite.appreciation
                      : '###'
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12 col-lg-6">
          <button
            type="button"
            class="btn btn-secondary mr-4"
            @click.prevent="$router.push({ name: listUrl }).catch(() => {})"
          >
            Liste des activités
          </button>
          <button
            v-if="
              currentOffre.statut === 0 && currentCandidature.embauche === false
            "
            type="button"
            class="btn btn-custom-primary mr-4"
            @click.prevent="
              $router
                .push({
                  name: listUrl + '-create',
                  id: currentCandidature.id,
                  offreId: offreId,
                  prov: prov,
                })
                .catch(() => {})
            "
          >
            <i class="fas fa-plus"></i>
            Nouvelle activité
          </button>
          <button
            type="button"
            class="btn btn-custom-primary"
            @click.prevent="
              $router
                .push({
                  name: listUrl + '-show',
                  params: {
                    activiteId: currentActivite.id,
                    id: currentCandidature.id,
                    offreId: offreId,
                    prov: prov,
                  },
                })
                .catch(() => {})
            "
          >
            <i class="fa fa-eye font-size-17"></i> Aperçu
          </button>
        </div>
        <div class="col-md-12 col-lg-6" v-if="currentOffre.statut === 0">
          <button
            type="button"
            class="btn btn-custom-primary"
            @click="showModalAppreciation"
          >
            {{
              currentActivite.appreciation
                ? "Changer l'appréciation"
                : 'Donner une appréciation'
            }}
          </button>
        </div>
      </div>
      <div class="mt-4">
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
          <alert-error
            v-if="form.errors.get('message')"
            :form="form"
            :message="form.errors.get('message')"
          ></alert-error>
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body mb-n2">
                  <div class="row justify-content-lg-center">
                    <div class="col-md-6 col-lg-2">
                      <div class="form-group">
                        <label for="date_debut"
                          >Date début <span class="text-danger">*</span></label
                        >
                        <date-picker
                          v-model="form.date_debut"
                          name="date_debut"
                          placeholder="Date début"
                          type="datetime"
                          lang="fr"
                          format="DD/MM/YYYY HH:mm"
                          value-type="DD/MM/YYYY HH:mm"
                        ></date-picker>
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('date_debut'),
                          }"
                          type="hidden"
                        />
                        <has-error :form="form" field="date_debut"></has-error>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-2">
                      <div class="form-group">
                        <label for="date_fin">Date fin </label>
                        <date-picker
                          v-model="form.date_fin"
                          name="date_fin"
                          placeholder="Date fin"
                          type="datetime"
                          lang="fr"
                          format="DD/MM/YYYY HH:mm"
                          value-type="DD/MM/YYYY HH:mm"
                        ></date-picker>
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('date_fin'),
                          }"
                          type="hidden"
                        />
                        <has-error :form="form" field="date_fin"></has-error>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                      <div class="form-group">
                        <label for="titre"
                          >Titre <span class="text-danger">*</span></label
                        >
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('titre'),
                          }"
                          id="titre"
                          v-model="form.titre"
                          type="text"
                          placeholder="Titre"
                          maxlength="50"
                          required
                        />
                        <has-error :form="form" field="titre"></has-error>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mt-n4 mt-lg-0">
                      <div class="custom-control custom-checkbox mt-4 pt-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="notifier"
                          v-model="form.notifier"
                        />
                        <label class="custom-control-label" for="notifier"
                          >Alerter le candidat par email</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-alert
            :show="form.errors.has('description')"
            dismissible
            variant="danger"
            class="mt-1"
          >
            <span v-html="form.errors.get('description')"></span>
          </b-alert>

          <div class="row">
            <div class="col-md-12">
              <b-card
                class="text-black"
                header-class="bg-silver border-bottom-0"
                no-body
              >
                <template #header>
                  <div>
                    <h5 class="font-size-16 mb-0">
                      <i class="mdi mdi-comment-edit mr-0"></i>
                      Description
                    </h5>
                  </div>
                </template>
                <div class="row editor">
                  <div class="col-md-12">
                    <vue-editor
                      id="fonction-mission"
                      v-model="form.description"
                      :editorToolbar="VueEditorToolbar"
                      class="fonction-mission"
                    />
                  </div>
                </div>
              </b-card>
            </div>
          </div>

          <div class="row mb-4 mt-2">
            <div class="col-md-12 text-right">
              <ButtonLoader
                :busy="form.busy"
                type="submit"
                customClass="btn btn-custom-primary w-40"
                loadText="Traitement en cours..."
                Text="Enregistrer"
                style="min-width: 100px"
              ></ButtonLoader>
            </div>
          </div>
        </form>
      </div>
    </div>
    <ModalAppreciation
      ref="modalAppreciation"
      :currentActivite="currentActivite"
      @onChangeAppreciation="onChangeAppreciation"
    />
  </div>
</template>

<script>
import URL from '@/http/rh/candidature/activite';
import { mapGetters } from 'vuex';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';
import { VueEditor } from 'vue2-editor';
import VueEditorToolbar from '@/vue-editor-tool-bar';
import ModalAppreciation from './ModalAppreciation.vue';

export default {
  data() {
    return {
      form: new Form({
        date_debut: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        date_fin: '',
        titre: '',
        description: '',
        notifier: false,
      }),
      currentActivite: null,
      VueEditorToolbar,
      prov: this.$route.params.prov,
      offreId: this.$route.params.offreId,
    };
  },
  computed: {
    listUrl() {
      return this.$route.name.split('-')[0];
    },
    ...mapGetters('candidature', ['currentCandidature']),
    ...mapGetters('offreEmploi', ['currentOffre']),
  },
  components: {
    DatePicker,
    VueEditor,
    ModalAppreciation,
  },
  methods: {
    showModalAppreciation() {
      this.$refs.modalAppreciation.showModal();
    },
    onChangeAppreciation(activite) {
      this.currentActivite = activite;
    },
    init() {
      window.axios
        .get(URL.ACTIVITE + '/' + this.$route.params.activiteId)
        .then((resp) => {
          this.currentActivite = resp.data.candidature_activite;
          Object.assign(this.form, resp.data.candidature_activite);
        })
        .catch();
    },
    submit() {
      this.form
        .put(URL.ACTIVITE + '/' + this.$route.params.activiteId)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
